import {
  FormControl,
  FormHelperText,
  InputLabel,
  Autocomplete as MuiAutocomplete,
  AutocompleteProps as MuiAutocompleteProps,
  TextField,
  TextFieldProps,
} from '@mui/material';
import { useMemo } from 'react';

export type AutocompleteProps<
  T,
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined,
> = Omit<MuiAutocompleteProps<T, Multiple, DisableClearable, FreeSolo>, 'renderInput'> & {
  label?: string;
  helperText?: string;
  error?: boolean;
  placeholder?: string;
};

export const Autocomplete = <
  T,
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined,
>({
  placeholder,
  clearIcon,
  size,
  fullWidth,
  sx,
  label,
  helperText,
  error,
  ...props
}: AutocompleteProps<T, Multiple, DisableClearable, FreeSolo>) => {
  const clearIconStyles = useMemo(() => {
    if (clearIcon || clearIcon === undefined) return undefined;
    return { '&&& .MuiInputBase-root': { paddingLeft: '10px', paddingRight: '40px' } };
  }, [clearIcon]);
  return (
    <FormControl size={size} fullWidth={fullWidth} sx={sx}>
      {label && <InputLabel>{label}</InputLabel>}
      <MuiAutocomplete
        {...props}
        clearIcon={clearIcon}
        size={size}
        fullWidth={fullWidth}
        renderInput={params => {
          return (
            <TextField
              {...(params as unknown as TextFieldProps)}
              sx={clearIconStyles}
              placeholder={placeholder}
              error={error}
              inputProps={{
                ...params.inputProps,
                autoComplete: 'new-password', // disable autocomplete and autofill
              }}
            />
          );
        }}
      />
      {helperText && <FormHelperText error={error}>{helperText}</FormHelperText>}
    </FormControl>
  );
};
